import React, { useState, useRef, useEffect } from "react";

// Image wrapper with shimmer placeholder until loaded
// Prevents layout-shift / bounce when async images arrive.
// Parent should be position: relative and have a known size.
const SmartImage = ({
    src,
    alt = "",
    className = "",
    onLoad: onLoadProp,
    shimmerClassName = "",
    eager = false,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    const imgRef = useRef(null);

    // Handle case where image is already in browser cache and onLoad never fires
    useEffect(() => {
        const img = imgRef.current;
        if (!img) return;
        if (img.complete && img.naturalWidth > 0) {
            setLoaded(true);
            if (onLoadProp) onLoadProp();
        } else if (img.complete && img.naturalWidth === 0) {
            setErrored(true);
        }
    }, [src]); // re-check when src changes

    return (
        <>
            {!loaded && !errored && (
                <div
                    aria-hidden
                    className={`absolute inset-0 ios-shimmer pointer-events-none ${shimmerClassName}`}
                />
            )}
            <img
                ref={imgRef}
                src={src}
                alt={alt}
                loading={eager ? "eager" : "lazy"}
                decoding='async'
                draggable={false}
                onLoad={() => {
                    setLoaded(true);
                    if (onLoadProp) onLoadProp();
                }}
                onError={() => setErrored(true)}
                className={`${className} transition-opacity duration-500 ease-out ${
                    loaded ? "opacity-100" : "opacity-0"
                }`}
            />
        </>
    );
};

export default SmartImage;
